import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';

const routes = {
  upload: `/files/upload`,
  consultId: (fileId: number) => `/files/${fileId}`,
  downloadBase64PorId: (fileId: number) => `/files/${fileId}/base64`,
  getMetadata: (fileId: number) => `/files/${fileId}/metadata`,
  edit: (fileId: number) => `/files/${fileId}/metadata`,
  editAll: `/files/metadata`,
  removerImagensRoupa: (roupaId: number) => `/roupas/${roupaId}/imagens`,
}

@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private readonly apiService: ApiService) { }

  upload(file: any) {
    const formData: FormData = new FormData();
    formData.append('file', file);
    return this.apiService.upload(routes.upload, formData);
  }

  consultarPorId(fileId: number) {
    return this.apiService.downloadImageAsBase64(routes.consultId(fileId))
  }

  getMetadata(fileId: number) {
    return this.apiService.get<any>(routes.getMetadata(fileId));
  }

  updateDetalhes(fileId: number, obj: any) {
    return this.apiService.patch(routes.edit(fileId), obj);
  }

  updateDetalhesBatch(obj: any) {
    return this.apiService.patch(routes.editAll, obj);
  }

  removerSelecionados(roupaId: number, fileIds: number[]) {
    return this.apiService.delete<any>(routes.removerImagensRoupa(roupaId), { ids: fileIds });
  }

  downloadBase64PorId(fileId: number) {
    return this.apiService.downloadImageAsBase64(routes.downloadBase64PorId(fileId))
  }
}
